import accreditation from './Accreditation/Resources/assets/js/store/';
import common from './Common/Resources/assets/js/store/';
import registeruser from './RegisterUser/Resources/assets/js/store/';
import masterdata from './MasterData/Resources/assets/js/store/';
import treasury from './Treasury/Resources/assets/js/store/';
import evaluatorReview from './AccreditationEvaluatorReview/Resources/assets/js/store/';
import qualityManagement from './AccreditationQualityManagement/Resources/assets/js/store/';
import evaluationTeam from './EvaluationTeam/Resources/assets/js/store/';
import form from './Form/Resources/assets/js/store/';

export default {
  accreditation,
  common,
  registeruser,
  masterdata,
  treasury,
  evaluatorReview,
  qualityManagement,
  evaluationTeam,
  form,
}